import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import styles from './ActivityHeader.module.scss';
const ActivityHeader = ({ showFilters, setShowFilters, filters, onChange }) => {
    const { t } = useTranslation();
    const [selected, setSelected] = useState((filters === null || filters === void 0 ? void 0 : filters.type) || 'all');
    const handleSelect = (type) => {
        setSelected(type);
        onChange({ type: type });
    };
    const filterItems = [
        { type: 'all', label: t('label.all') },
        { type: 'provider_assignment', label: t('dashboard.consultation') },
        { type: 'lab_results', label: t('dashboard.lab_results') },
        { type: 'telehealth_appointment', label: t('dashboard.telehealth_visits') },
    ];
    return (_jsx("div", Object.assign({ className: styles.header }, { children: _jsxs("div", Object.assign({ className: styles.title }, { children: [_jsx("div", Object.assign({ className: styles.label }, { children: t('label.activity_feed') })), _jsx("div", Object.assign({ className: styles.controls }, { children: filterItems.map((item) => (_jsx("div", Object.assign({ className: clsx(styles.controlsItem, {
                            [styles.controlsItemSelected]: selected === item.type,
                        }), onClick: () => handleSelect(item.type) }, { children: item.label }), item.type))) })), _jsx("div", Object.assign({ className: styles.filter }, { children: _jsx(Button, Object.assign({ onClick: setShowFilters, mode: ['custom-filters', 'sm'], leftElement: "filtersList", isActive: Boolean(showFilters) }, { children: t('label.filters') })) }))] })) })));
};
export default observer(ActivityHeader);
